import { createSlice } from "@reduxjs/toolkit";

import type { UserBillingAddress } from "@app/types/napi-types";

import type { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

type BillingAddressState = UserBillingAddress | null;

const updateUserBillingAddressStateReducer: CaseReducer<
  BillingAddressState,
  PayloadAction<UserBillingAddress>
> = (state, { payload: updated_user_billing_address }) => {
  state = updated_user_billing_address;
  return state;
};

const deleteUserBillingAddressStateReducer: CaseReducer<
  BillingAddressState,
  PayloadAction
> = () => {
  return null;
};

const user_billing_address = createSlice({
  name: "user_billing_address",
  initialState: null as BillingAddressState,
  reducers: {
    updateUserBillingAddressState: updateUserBillingAddressStateReducer,
    deleteUserBillingAddressState: deleteUserBillingAddressStateReducer
  }
});

export const { updateUserBillingAddressState, deleteUserBillingAddressState } =
  user_billing_address.actions;
export default user_billing_address.reducer;
